// extracted by css-extract-rspack-plugin
export default {"container":"TextBuildingBlockPicker_container__hRUnF","search":"TextBuildingBlockPicker_search__OQrAC","items":"TextBuildingBlockPicker_items__MyK39"};